import { useCallback } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';
import { FavoriteReference } from 'shared/types/user-settings';

import { useUpdateUserSettings } from './use-update-user-settings';

export const useReorderFavorites = () => {
  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();

  return useCallback(
    (ids: ID[]) => {
      const newFavorites = ids.reduce<FavoriteReference[]>((acc, id) => {
        const favorite = user?.settings?.favorites?.find(
          (fav) => fav.id === id,
        );

        if (favorite) {
          acc.push(favorite);
        }

        return acc;
      }, []);

      updateUserSettings({ favorites: newFavorites });
    },
    [updateUserSettings, user?.settings?.favorites],
  );
};
